import useSite from "./useSite";
import authService from "@/services/AuthService";
import { resolveTimeZone } from "@/utils/formatInSiteTz";

/**
 * Returns the timezone to use for rendering dates/times.
 * Precedence: user profile override → site setting → undefined (browser local).
 *
 * The value is always run through resolveTimeZone(), so it is guaranteed to be
 * either a valid IANA zone or undefined — never a Windows TZ name or other
 * string that would make Date.toLocaleString throw a RangeError. Safe to pass
 * straight to toLocaleString or the formatInSiteTz helpers.
 */
export default function useResolvedTimezone(): string | undefined {
  const { site } = useSite();
  const userTz = (authService.profile as { timeZone?: string })?.timeZone;
  return resolveTimeZone(userTz || site?.timezone || undefined);
}
